import { registerPlugin } from '@capacitor/core';

import type { AdmobAdsPlugin } from './definitions';

const AdmobAds = registerPlugin<AdmobAdsPlugin>('AdmobAds', {
  web: () => import('./web').then(m => new m.AdmobAdsWeb()),
});

export * from './definitions';
export { AdmobAds };
